import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';

const Pcontainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  overflow: hidden; /* Keeps the container tidy */
`;

const ScrollBox = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  line-height: 1.6;
  color: #333;
  font-size: 0.9rem;
  background: #fafafa;
`;

const CenteredH1 = styled.h1`
  text-align: center;
  margin-top: 0;
  color: #222;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: ${props => props.secondary ? '#6c757d' : '#007bff'};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: opacity 0.2s;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

function Terms() {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    // Logic for when user accepts (e.g., save to local storage or API)
    console.log("Terms Accepted");
    navigate('/dashboard'); // or wherever you want them to go
  };

  return (
    <Pcontainer>
      <Container>
        <CenteredH1>Terms and Conditions</CenteredH1>
        
        <ScrollBox>
        <strong>Disclaimer:</strong> Predictions are generated via historical data models and are for informational and entertainment purposes only. Past performance does not guarantee future results. We are not a sportsbook and do not accept wagers. 
    <br /><br />
    <strong>If you or someone you know has a gambling problem, call 1-800-GAMBLER.</strong>

  <h3>1. Acceptance of Terms</h3>
  <p>By accessing this site, you agree to be bound by these terms of service and all applicable laws and regulations.</p>

  <h3>2. Nature of Service</h3>
  <p>StatTracker is a sports analytics and data visualization tool. All "predictions," "projections," or "value ratings" are the result of automated statistical algorithms based on historical player performance. These are opinions, not financial advice or guarantees of outcome.</p>

  <h3>3. No Guarantees</h3>
  <p>While we strive for maximum data accuracy, StatTracker does not warrant that the information provided is 100% accurate, complete, or current. Sports involve human variables that no model can fully predict (e.g., late-game injuries, coaching decisions, or ejections).</p>

  <h3>4. Limitation of Liability</h3>
  <p>By using this app, you acknowledge that you are responsible for your own financial decisions. StatTracker, its creators, and affiliates are not responsible for any financial losses incurred as a result of using our data. Users should only wager what they can afford to lose.</p>

  <h3>5. Not a Gambling Platform</h3>
  <p>StatTracker is not a sportsbook and does not facilitate betting. We do not take a percentage of any wagers and are not involved in the payout of any bets placed on third-party platforms.</p>

  <h3>6. Age Requirement</h3>
  <p>Users must be 18+ (21+ in certain jurisdictions) to use this service.</p>

  <h3>7. Use License</h3>
  <p>Permission is granted to temporarily download one copy of the materials on this website for personal, non-commercial transitory viewing only.</p>

  <h3>8. User Responsibilities</h3>
  <p>You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>

  <h3>9. Privacy Policy</h3>
  <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect and use your information.</p>
          <p><em>Last updated: January 2026</em></p>
        </ScrollBox>

        {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
          <input 
            type="checkbox" 
            id="agree" 
            checked={accepted} 
            onChange={(e) => setAccepted(e.target.checked)} 
          />
          <label htmlFor="agree" style={{ marginLeft: '10px' }}>
            I have read and agree to the Terms and Conditions
          </label>
        </div>

        <ButtonGroup>
          <Button secondary onClick={() => navigate(-1)}>Decline</Button>
          <Button disabled={!accepted} onClick={handleAccept}>Accept & Continue</Button>
        </ButtonGroup> */}
      </Container>
    </Pcontainer>
  );
}

export default Terms;